<aside id="sidebar" class="js-sidebar">
  <div class="h-100">
    <div class="sidebar-logo">
      <a routerLink="/dashboard"
        ><img
          src="assets/img/cooxupe-simbol.svg"
          alt="Simbolo Cooxupe"
          width="32"
        />
        Sismet Admin</a
      >
    </div>
    <ul class="sidebar-nav">
      <li class="sidebar-header">{{ userRole }}</li>
      <li class="sidebar-item">
        <a routerLink="/dashboard" class="sidebar-link">
          <i class="fa-solid fa-list pe-2"></i>
          Dashboard
        </a>
      </li>
      <li class="sidebar-item">
        <a
          href="#"
          class="sidebar-link collapsed"
          data-bs-target="#menuPessoas"
          data-bs-toggle="collapse"
          aria-expanded="false"
        >
          <i class="fa-solid fa-users pe-2"></i>
          Pessoas
        </a>
        <ul
          id="menuPessoas"
          class="sidebar-dropdown list-unstyled collapse"
          data-bs-parent="#sidebar"
        >
          <li class="sidebar-item">
            <a routerLink="/cooperados" class="sidebar-link">Cooperados</a>
          </li>
          <li class="sidebar-item">
            <a routerLink="/colaboradores" class="sidebar-link"
              >Colaboradores</a
            >
          </li>
        </ul>
      </li>
      <li class="sidebar-item">
        <a
          href="#"
          class="sidebar-link collapsed"
          data-bs-target="#menuAreasRurais"
          data-bs-toggle="collapse"
          aria-expanded="false"
        >
          <i class="fa-solid fa-home pe-2"></i>
          Locais
        </a>
        <ul
          id="menuAreasRurais"
          class="sidebar-dropdown list-unstyled collapse"
          data-bs-parent="#sidebar"
        >
          <li class="sidebar-item">
            <a routerLink="/tipos-de-unidades" class="sidebar-link"
              >Tipos de Unidades</a
            >
          </li>
          <li class="sidebar-item">
            <a routerLink="/localidades" class="sidebar-link">Localidades</a>
          </li>
          <li class="sidebar-item">
            <a routerLink="/propriedades" class="sidebar-link">Propriedades</a>
          </li>
        </ul>
      </li>

      <li class="sidebar-item">
        <a
          href="#"
          class="sidebar-link collapsed"
          data-bs-target="#pagesEstacaoes"
          data-bs-toggle="collapse"
          aria-expanded="false"
          ><i class="fa-solid fa-tower-broadcast pe-2"></i>
          Estações
        </a>
        <ul
          id="pagesEstacaoes"
          class="sidebar-dropdown list-unstyled collapse"
          data-bs-parent="#sidebar"
        >
          <li class="sidebar-item">
            <a routerLink="/tipos-de-estacoes" class="sidebar-link"
              >Tipos de Estações</a
            >
          </li>
          <li class="sidebar-item">
            <a routerLink="/estacoes" class="sidebar-link"
              >Gerenciar Informações</a
            >
          </li>
          <li class="sidebar-item">
            <a routerLink="/estacoes/dados-historicos" class="sidebar-link"
              >Dados Históricos Diários</a
            >
          </li>
          <li class="sidebar-item">
            <a
              routerLink="/estacoes/dados-historicos-horarios"
              class="sidebar-link"
              >Dados Históricos Horários</a
            >
          </li>
          <li class="sidebar-item">
            <a routerLink="/estacoes/graficos" class="sidebar-link"
              >Gráfico de Temperatura e Chuva</a
            >
          </li>
          <li class="sidebar-item">
            <a
              routerLink="/estacoes/gerenciar-dados-faltantes"
              class="sidebar-link"
              >Dados Faltantes por Dia</a
            >
          </li>
          <li class="sidebar-item">
            <a
              routerLink="/estacoes/gerenciar-dados-faltantes-hora"
              class="sidebar-link"
              >Dados Faltantes por Hora</a
            >
          </li>
        </ul>
      </li>

      <li class="sidebar-item">
        <a
          href="#"
          class="sidebar-link collapsed"
          data-bs-target="#pagesBalancoHidrico"
          data-bs-toggle="collapse"
          aria-expanded="false"
          ><i class="fa-solid fa-droplet pe-2"></i>
          Balanço Hídrico
        </a>
        <ul
          id="pagesBalancoHidrico"
          class="sidebar-dropdown list-unstyled collapse"
          data-bs-parent="#sidebar"
        >
          <li class="sidebar-item">
            <a routerLink="/balanco-hidrico" class="sidebar-link">
              Consultar Dados
            </a>
          </li>
          <li class="sidebar-item">
            <a routerLink="/balanco-hidrico/calcular" class="sidebar-link">
              Calcular Balanço Hídrico
            </a>
          </li>
        </ul>
      </li>

      <li class="sidebar-item">
        <a
          href="#"
          class="sidebar-link collapsed"
          data-bs-target="#pagesPluviometros"
          data-bs-toggle="collapse"
          aria-expanded="false"
          ><i class="fa-solid fa-cloud-rain pe-2"></i>
          Pluviômetros
        </a>
        <ul
          id="pagesPluviometros"
          class="sidebar-dropdown list-unstyled collapse"
          data-bs-parent="#sidebar"
        >
          <li class="sidebar-item">
            <a routerLink="/pluviometros" class="sidebar-link"
              >Gerenciar Pluviômetro</a
            >
          </li>
          <li class="sidebar-item">
            <a routerLink="/pluviometros/dados" class="sidebar-link"
              >Dados de Pluviômetros</a
            >
          </li>
          <li class="sidebar-item">
            <a
              routerLink="/pluviometros/estimar-temperatura"
              class="sidebar-link"
              >Estimar Temperatura</a
            >
          </li>
        </ul>
      </li>

      <li class="sidebar-item">
        <a
          href="#"
          class="sidebar-link collapsed"
          data-bs-target="#pagesFlowering"
          data-bs-toggle="collapse"
          aria-expanded="false"
          ><i class="fa-solid fa-seedling pe-2"></i>
          Ciclo Fenológico
        </a>
        <ul
          id="pagesFlowering"
          class="sidebar-dropdown list-unstyled collapse"
          data-bs-parent="#sidebar"
        >
          <li class="sidebar-item">
            <a routerLink="/floradas" class="sidebar-link"
              >Visualizar Floradas</a
            >
          </li>
          <li class="sidebar-item">
            <a routerLink="/floradas/observacoes" class="sidebar-link"
              >Observações das Floradas</a
            >
          </li>
        </ul>
      </li>
      <li class="sidebar-item">
        <a
          href="#"
          class="sidebar-link collapsed"
          data-bs-target="#pagesSad"
          data-bs-toggle="collapse"
          aria-expanded="false"
          ><i class="fa-solid fa-triangle-exclamation pe-2"></i>
          Sistema de Alerta de Doenças
        </a>
        <ul
          id="pagesSad"
          class="sidebar-dropdown list-unstyled collapse"
          data-bs-parent="#sidebar"
        >
          <li class="sidebar-item">
            <a routerLink="/sad/ferrugem" class="sidebar-link">Ferrugem</a>
          </li>
          <li class="sidebar-item">
            <a routerLink="/sad/phoma" class="sidebar-link">Phoma</a>
          </li>
        </ul>
      </li>
      <li class="sidebar-item">
        <a routerLink="/viabilidades-economicas" class="sidebar-link">
          <i class="fa-solid fa-chart-line pe-2"></i>
          Viabilidade Econômica
        </a>
      </li>

      <li class="sidebar-item">
        <a
          href="#"
          class="sidebar-link collapsed"
          data-bs-target="#pagesCultivar"
          data-bs-toggle="collapse"
          aria-expanded="false"
        >
          <i class="fa-solid fa-leaf pe-2"></i>
          Cultivar
        </a>
        <ul
          id="pagesCultivar"
          class="sidebar-dropdown list-unstyled collapse"
          data-bs-parent="#sidebar"
        >
          <li class="sidebar-item">
            <a routerLink="/cultivar/propriedade" class="sidebar-link"
              >Cultivar-Propriedade</a
            >
          </li>
        </ul>
      </li>

      <li class="sidebar-item">
        <a href="#" (click)="openReportTypeModal($event)" class="sidebar-link">
          <i class="fa-solid fa-file-lines pe-2"></i>
          Relatórios
        </a>
      </li>

      <li class="sidebar-item">
        <a
          href="#"
          class="sidebar-link collapsed"
          data-bs-target="#pagesGerenciarSismetWeb"
          data-bs-toggle="collapse"
          aria-expanded="false"
        >
          <i class="fa-solid fa-globe pe-2"></i>
          Gerenciar Sismet Web
        </a>
        <ul
          id="pagesGerenciarSismetWeb"
          class="sidebar-dropdown list-unstyled collapse"
          data-bs-parent="#sidebar"
        >
          <li class="sidebar-item">
            <a routerLink="/imagens-carrossel" class="sidebar-link"
              >Imagens do Carrossel</a
            >
          </li>
          <li class="sidebar-item">
            <a routerLink="/noticias" class="sidebar-link">Notícias</a>
          </li>
        </ul>
      </li>

      <li class="sidebar-item">
        <a routerLink="/configuracoes" class="sidebar-link">
          <i class="fa-solid fa-gear pe-2"></i>
          Configurações
        </a>
      </li>
    </ul>
  </div>
</aside>

<!-- Modal de seleção de tipo de relatório -->
<app-report-type-selector></app-report-type-selector>
